<template>
  <el-dialog :title="this.$t('user.change_password.title')" :visible.sync="dialogFormVisible" @closed="closed">
    <el-form ref="changePasswordForm" label-position="right" label-width="180px" :model="formData" :rules="rules">
      <el-form-item :label="this.$t('user.change_password.form.current_password')" prop="current_password">
        <el-input type="password" v-model="formData.current_password"></el-input>
      </el-form-item>
      <el-form-item :label="this.$t('user.change_password.form.password')" prop="password">
        <el-input type="password" v-model="formData.password"></el-input>
      </el-form-item>
      <el-form-item :label="this.$t('user.change_password.form.password_confirmation')" prop="password_confirmation">
        <el-input type="password" v-model="formData.password_confirmation"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer" style="display: block; text-align: right">
      <el-button @click="closed">{{this.$t('user.change_password.button.cancel')}}</el-button>
      <el-button @click="handleChangePassword" type="primary">{{this.$t('user.change_password.button.update')}}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import {mapActions} from 'vuex'

export default {
  name: 'ChangePasswordModal',
  data () {
    let validatePassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('user.required')))
      } else {
        if (this.formData.password !== '') {
          this.$refs.changePasswordForm.validateField('password_confirmation')
        }
        callback()
      }
    }
    let validatePasswordConfirmation = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('user.required')))
      } else if (value !== this.formData.password) {
        callback(new Error(this.$t('user.change_password.message.password_not_match')))
      } else {
        callback()
      }
    }
    return {
      dialogFormVisible: false,
      formData: {
        current_password: null,
        password: null,
        password_confirmation: null
      },
      rules: {
        current_password: [
          {required: true, message: this.$t('user.required'), trigger: 'blur'}
        ],
        password: [
          { required: true, validator: validatePassword, trigger: 'blur' }
        ],
        password_confirmation: [
          { required: true, validator: validatePasswordConfirmation, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    ...mapActions({
      changePasswordAction: 'user/changePasswordAction'
    }),
    show () {
      this.dialogFormVisible = true
    },
    closed () {
      this.$refs.changePasswordForm.resetFields()
      this.dialogFormVisible = false
    },
    async handleChangePassword () {
      let that = this
      await this.$refs.changePasswordForm.validate(async (valid) => {
        if (valid) {
          const response = await this.changePasswordAction(this.formData)
          if (response.status === 200) {
            this.$message({
              message: that.$t('user.change_password.message.change_successful'),
              type: 'success'
            })
            this.dialogFormVisible = false
          } else {
            this.$message.error(that.$t('user.change_password.message.change_failed'))
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/user/components/ChangePasswordModal.vue